<template>
    <div>
        <div class="modal fade modal-md show" id="modalDiscard" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-modal="true" role="dialog" style="display: block;">
            <div class="modal-dialog modal-dialog-centered">

                <div class="modal-content discard-wrap">
                    <div class="modal-header px-0 pt-0 pb-3.5">
                        <div class="flex items-center justify-start">
                            <div class="flex items-center gap-2">
                                <span class="w-2 h-2 rounded-full bg-[#FE5000]"></span>
                                <span class="w-10 h-2 rounded-full bg-[#FE5000]"></span>
                                <h2 class="m-0 font-lato font-[700] text-[20px] text-[#092E87]">Cancel Quote</h2>
                            </div>
                        </div>
                    </div>
                    <div v-if="Object.keys(quoteDetail).length > 0" class="!px-0">
                        <div class="contPopup">
                            <div class="cardSec">
                                <h6 class="my-2">Cancellation Reason</h6>

                                <select v-model="reason" class="form-select form-select-sm"
                                    aria-label=".form-select-sm example">
                                    <option value="" selected disabled>Select Option</option>
                                    <option v-for="(item, idx) in cancelReasons" :key="idx">
                                        {{ item }}
                                    </option>
                                </select>
                                <div v-if="reason == 'Other'">
                                    <h6 class="my-2">Please mention reason</h6>
                                    <textarea v-model="reasonText" class="form-control myTextHere"
                                        placeholder="Enter Text here..."></textarea>
                                </div>
                            </div>
                            <div v-if="quoteDetail && quoteDetail.partner_info && quoteDetail.partner_info.is_tradecall_fee_applicable == 1"
                                class="cardSec mt-4 ">
                                <h6>A TradeCall fee for {{ quoteDetail.partner_info.tradecall_fee_text }} is
                                    applicable on this claim. Have you collected the TradeCall fee from {{
                                        quoteDetail.consumer.full_name }} ?</h6>
                                <div class="d-flex radioBtn">
                                    <label><input v-model="check" type="radio" value="1"> Yes</label>
                                    <label class="ms-auto"><input v-model="check" type="radio" value="0"> No</label>
                                </div>
                            </div>

                            <div v-if="quoteDetail && quoteDetail.partner_info.is_show_multi_units == 1"
                                class="cardSec mt-4 ">
                                <h6>Did you diagnose multiple units at this service address? </h6>
                                <div class="d-flex radioBtn">
                                    <label><input v-model="checkMultiSystem" type="radio" value="1"> Yes</label>
                                    <label class="ms-auto"><input v-model="checkMultiSystem" type="radio" value="0">
                                        No</label>
                                </div>
                            </div>
                            <div class="flex justify-center gap-2.5 mt-4">
                                <button @click="closeModal"
                                    class="px-4 py-[10px] rounded-lg text-[16px] font-lato transition duration-300 bg-[#003087] text-[#fff]">
                                    Dismiss
                                </button>
                                <button @click="confirm()"
                                    class="px-4 py-[10px] rounded-lg text-[16px] font-lato transition duration-300 bg-[#FE5000] text-[#fff]">
                                    Cancel Quote
                                </button>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
import {
    mapActions,
    mapGetters,
} from "vuex";
import { useToast } from 'vue-toastification';
import { enableScroll } from "../../helpers/scrollHelper";
const toast = useToast();


export default {
    components: {

    },

    data() {
        return {
            check: '',
            reason: '',
            reasonText: '',
            checkMultiSystem: -1
        }
    },
    computed: {
        ...mapGetters(["quoteDetail", "apptDetail", "cancelReasons"])
    },

    watch: {

    },

    mounted() {

    },

    methods: {
        ...mapActions(["setCommponent"]),

        editQuoteClicked() {
            this.setCommponent("QuoteItems")
        },

        closeModal() {
            this.check = ''
            this.reason = ''
            this.checkMultiSystem = -1
            document.documentElement.style.overflow = '';
            enableScroll()
            this.$emit("event", "close")
        },

        confirm() {
            if (this.reason.length <= 0) {
                toast.error("Reason field is required.");
            } else if (this.reason == "Other" && this.reasonText.length <= 0) {
                toast.error("Reason field is required.");
            } else if (this.quoteDetail.partner_info && this.quoteDetail.partner_info.is_tradecall_fee_applicable == 1 && this.check.length <= 0) {
                toast.error("Please confirm have you collected the TradeCall fee.");
            }
            else if (this.quoteDetail.partner_info.is_show_multi_units == 1 && this.checkMultiSystem == -1) {
                toast.error("Please indicate if you diagnosed more than one unit at this service address.");
            }

            else {
                let ch = this.check.length <= 0 ? "0" : this.check
                let res = this.reason == "Other" ? this.reasonText : this.reason
                this.$emit("event", "confirm", { is_tradecall_fee_collected: ch, reason: res, is_decline_multi_units: this.checkMultiSystem })
                this.check = ''
                this.reason = ''
            }

        },
    }

}
</script>

<style>
.modals-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modals {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
}

.discard-wrap {
    border-radius: 20px;
    box-shadow: 0 0 10px #fff;
}

.discard-wrap .modal-header {
    border: none;
}

.continue-popup .modal-header .close {
    position: absolute;
    top: 30px;
    right: 30px;
    background: #ff5b01;
    opacity: 1;
    padding: 0;
    height: 27px;
    width: 27px;
    border-radius: 50px;
    color: #fff;
    box-shadow: 0 2px 3px #444;
    font-weight: 100;
}

.continue-popup .modal-header {
    padding: 0;
    border: none;
}

.continue-popup {
    border-radius: 12px;
    box-shadow: 0 0 10px #fff;
    border: none;
}

/* .contPopup h1 {
    color: #003087;
    font-size: 25px;
    font-weight: 600;
    text-shadow: 0 1px 3px #666;
    margin-top: -30px;
}
 
.contPopup p {
    color: #000000;
    font-size: 15px;
} */

.btnClose {
    position: absolute;
    background: none;
    right: 10px;
    padding: 0;
    border: none;
    border-radius: 50px;
    z-index: 9;
    font-weight: bold;
}

.myCheckText {
    color: #ff5b01;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.myCheck {
    height: 15px;
    width: 15px;
    accent-color: #ff5b01;
}

.disBtn {
    background-color: #003087 !important;
}

.myTextHere {
    height: 80px;
    resize: none;
    font-size: .875rem;
}

.radioBtn {
    max-width: 200px;
    accent-color: #ff5b01;
}

.cardSec {
    background-color: #f8f8f8;
    border-radius: 10px !important;
    padding: 10px;


}

.cardSec p {
    font-size: 16px !important;
    color: black !important;
}


@media screen and (max-width:767px) {}
</style>